import { MessagingPageComponent } from './containers/messaging-page.component';
import { MessagingWrapperComponent } from './containers/messaging-wrapper.component';
export var COMPONENTS = [MessagingPageComponent, MessagingWrapperComponent];
var MessagingModule = /** @class */ (function () {
    function MessagingModule() {
    }
    return MessagingModule;
}());
export { MessagingModule };
